import React from "react";
import { Redirect, useLocation } from "react-router-dom";

// There used to be two general-chat screens: this one (a single conversation,
// reached from the bell, emails and "Ask a question") and the Messages page
// (all conversations, reached from the envelope icon). They looked different
// and the single-conversation one couldn't switch rooms in place, so
// opening a second notification here showed the old chat. Everything now
// goes to the Messages page; this route only survives for old links.
const AskQuestion = () => {
  const location = useLocation();
  const roomId = new URLSearchParams(location.search).get("roomId");
  return (
    <Redirect to={roomId ? `/chat-history?roomId=${roomId}` : "/chat-history"} />
  );
};

export default AskQuestion;
